<template>
  <div @click="onClick"
       class="vacancy-card-new">
    <div class="vacancy-card-new__inner">
      <VacancyCardImages
        :vacancy="vacancy"
        class="_no-link"
      />

      <VacancyCardInfo
        :vacancy="vacancy"
        :employer="vacancy.employer"
      />

      <div
        v-if="vacancy.employer"
        class="vacancy-card-new__side"
      >
        <VacancyCardEmployer
          class="vacancy-card-new__side-header"
          :employer="vacancy.employer"
        />

        <div class="vacancy-card-new__side-footer" v-if="false">
          <div class="vacancy-card-new__rating-wrap" >
            <div class="vacancy-card-new__employer-label">
              <span>{{ $tVacancy('Assessment of applicants') }}</span>
              <BaseHelp class="vacancy-card-new__side-help"
                        value="Some text by props value"
              />
            </div>
            <div class="vacancy-card-new__rating">
              <div class="vacancy-card-new__rating-stars">
                <BaseSvg
                  v-for="(star) in 5"
                  name="ico-star"
                  :key="star"
                  :class="{ _active: true }"
                />
              </div>
            </div>
          </div>

          <div class="vacancy-card-new__side-links">
            <router-link-modified
              to="#"
              tag="a"
              class="vacancy-card-new__side-link inline-link"
            >
              <span>{{ $tVacancy('Reviews') }}</span>&nbsp;
              <BaseSvg
                class="_arrow"
                name="ico-arrow-light"
              />
            </router-link-modified>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
  import VacancyCardEmployer from '@/components/vacancy-card/VacancyCardEmployer';
  import VacancyCardImages from '@/components/vacancy-card/VacancyCardImages';
  import VacancyCardInfo from '@/components/vacancy-card/VacancyCardInfo';

  export default {
    name: 'VacancyCard',

    components: {
      VacancyCardInfo,
      VacancyCardImages,
      VacancyCardEmployer,
    },

    props: {
      data: {
        type: Object,
        required: true
      }
    },

    computed: {
      vacancy() {
        return this.data || {};
      },
    },
    methods: {
      onClick(e) {
        if(e.target.closest('._no-link, a, button')) return

        this.$router.push({
          name: 'vacancy',
          params: {
            vacancyId: this.vacancy[1].slug
          }
        })
      }
    }
  };
</script>
